import { render, staticRenderFns } from "./ClaimsList.vue?vue&type=template&id=0f821bf4&"
import script from "./ClaimsList.vue?vue&type=script&lang=js&"
export * from "./ClaimsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports